module.exports = __webpack_public_path__ + "img/operationalAssetMgt.f9ba2ee2.svg";